import styled, { css } from 'styled-components';
import type { ButtonProps } from '@elfsight/widget-ui';
import { Button, Loader } from '@elfsight/widget-ui';
import { getInvertedColor } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { BUTTON_TEXT_STYLE } from './typography';

type ActionButtonProps = Pick<
  ButtonProps,
  'onClick' | 'children' | 'disabled'
> & {
  loading?: boolean;
  centered?: boolean;
};

export function ActionButton({
  children,
  centered = true,
  loading,
  ...forwardingProps
}: ActionButtonProps) {
  const { accentColor } = useSettings();
  const invertedColor = getInvertedColor(accentColor);

  return (
    <CenteredButton
      _centered={centered}
      color={accentColor}
      fontColor={invertedColor}
      font={BUTTON_TEXT_STYLE}
      borderRadius={8}
      height={44}
      {...forwardingProps}
    >
      <OverlayLoader size={24} color={invertedColor} _loading={loading} />
      <Text _loading={loading}>{children}</Text>
    </CenteredButton>
  );
}

const CenteredButton = styled(Button)<{ _centered?: boolean }>`
  min-width: 200px;
  flex-shrink: 0;
  ${({ _centered }) =>
    _centered &&
    css`
      margin: 0 auto;
    `}
`;

const Text = styled.div<{ _loading?: boolean }>`
  opacity: ${({ _loading }) => (_loading ? 0 : 1)};
`;
const OverlayLoader = styled(Loader)<{ _loading?: boolean }>`
  position: absolute;
  inset: 0;
  opacity: ${({ _loading }) => (_loading ? 1 : 0)};
`;
